import { useForm } from 'react-hook-form';
import gYupResolver from '../../technical/form/gYupResolver.ts';
import * as yup from 'yup';
import { updateWidgetState, useWidgetState } from '../../management/customDashboard/CustomWidgetContext';
import { UserSettingsDocument, useUpdateUserSettingsMutation } from '../../../generated/graphql.tsx';
import WidgetSettings from '../../management/customDashboard/WidgetSettings';
import { FormPortfolioFilters } from 'components/technical/form/FormPortfolioFilters.tsx';
import {
  type PortfolioFilters,
  portfolioFiltersSchema,
} from 'components/technical/PortfolioFilterDrawer/UsePortfolioFilters';

const schema = yup
  .object({
    title: yup.string().required(),
  })
  .concat(portfolioFiltersSchema);

export interface PositionSummarySettingsState extends Partial<PortfolioFilters> {
  title: string;
}

export const PositionSummarySettings = ({
  id,
  onFinishedEditing,
  onRemovedWidget,
  presetKey,
}: {
  id: string;
  onFinishedEditing: () => void;
  onRemovedWidget: () => Promise<void>;
  presetKey: string;
}) => {
  const initialState = useWidgetState<PositionSummarySettingsState>(id);
  const updater = updateWidgetState<PositionSummarySettingsState>();
  const [updateUserSettings] = useUpdateUserSettingsMutation();

  const methods = useForm<PositionSummarySettingsState>({
    resolver: gYupResolver(schema),
    defaultValues: {
      ...initialState,
    },
  });

  const handleFormSubmit = async (input: PositionSummarySettingsState): Promise<void> => {
    await updater({
      id,
      state: {
        ...input,
        title: input.title,
      },
      updateBackend: true,
    });

    onFinishedEditing();
  };

  return (
    <WidgetSettings
      methods={methods}
      handleFormSubmit={handleFormSubmit}
      onRemovedWidget={async () => {
        await updateUserSettings({
          variables: {
            settings: {
              [presetKey]: null,
            },
          },
          refetchQueries: [UserSettingsDocument],
        });

        await onRemovedWidget();
      }}
    >
      <FormPortfolioFilters />
    </WidgetSettings>
  );
};
